/**
 * @class ServiceDepartment
 */
export default class ServiceDepartment {
    /**
     * @param {Number}  id
     * @param {String}  name
     */
    constructor(id, name) {
        this._id = id;
        this._name = name;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Service department");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {Object}
     */
    formattedObject() {
        return {
            id: this._id,
            name: this._name
        };
    }
}
